import { render, staticRenderFns } from "./CommentTile.vue?vue&type=template&id=577d3468&scoped=true&"
import script from "./CommentTile.vue?vue&type=script&lang=ts&"
export * from "./CommentTile.vue?vue&type=script&lang=ts&"
import style0 from "./CommentTile.vue?vue&type=style&index=0&id=577d3468&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d3468",
  null
  
)

export default component.exports